export default "__VITE_ASSET__CsDz63qE__"